import { useState } from "react";
import { categories } from "@/mocks/guatrend";

interface Props {
  onPick: (id: string) => void;
}

export default function CategorySection({ onPick }: Props) {
  const [active, setActive] = useState<string>("");

  const pick = (id: string) => {
    setActive(id);
    onPick(id);
    document.getElementById("collection")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="category" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-medium text-primary-600 whitespace-nowrap">CONTENT CATEGORY</p>
            <h2 className="font-display mt-2 text-2xl text-foreground-900 md:text-4xl">按口味挑选你的高分好瓜</h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            八大内容分类，每类都由真实网友口碑沉淀而成，点选即可直达对应高分合集。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => {
            const isActive = active === c.id;
            return (
              <button
                key={c.id}
                type="button"
                onClick={() => pick(c.id)}
                className={`group flex flex-col rounded-xl border p-5 text-left transition-all md:p-6 ${
                  isActive
                    ? "border-primary-500 bg-primary-500 text-background-50"
                    : "border-background-200 bg-background-50 hover:-translate-y-1 hover:border-primary-300"
                }`}
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                    isActive ? "bg-background-50/15 text-background-50" : "bg-primary-100 text-primary-700"
                  }`}
                >
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <span
                  className={`mt-4 text-base font-bold md:text-lg ${isActive ? "text-background-50" : "text-foreground-900"}`}
                >
                  {c.name}
                </span>
                <span
                  className={`mt-1 text-xs leading-relaxed ${isActive ? "text-background-50/80" : "text-foreground-500"}`}
                >
                  {c.desc}
                </span>
                <span
                  className={`mt-4 flex items-center justify-between text-xs ${
                    isActive ? "text-background-50/80" : "text-foreground-400"
                  }`}
                >
                  <span>{c.total} 个口碑合集</span>
                  <i
                    className={`ri-arrow-right-line transition-transform group-hover:translate-x-0.5 ${
                      isActive ? "" : "text-primary-500"
                    }`}
                  ></i>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}